import isText from './isText';

function arraysEqual(a: any[], b: any[]): boolean {
	if (a.length !== b.length) return false;
	for (let i = 0; i < a.length; i += 1) {
		if (!isEqual(a[i], b[i])) return false;
	}
	return true;
}

function objectsEqual(a: Record<string, unknown>, b: Record<string, unknown>): boolean {
	const aKeys = Object.keys(a);
	const bKeys = Object.keys(b);
	if (aKeys.length !== bKeys.length) return false;

	for (const key of aKeys) {
		if (!isEqual(a[key], b[key])) return false;
	}
	return true;
}

function convertToString(a: any): any {
	return JSON.parse(
		JSON.stringify(a, (_k, v) => {
			let result = v;
			if (typeof v === 'number') {
				result = v.toString();
			} else if (v === null) {
				result = '';
			}
			return result;
		}),
	);
}

function isEqual(a: any, b: any): boolean {
	a = convertToString(a);
	b = convertToString(b);

	if (Array.isArray(a) && Array.isArray(b)) {
		return arraysEqual(a, b);
	}

	if (a && typeof a === 'object' && b && typeof b === 'object') {
		return objectsEqual(a as Record<string, unknown>, b as Record<string, unknown>);
	}

	if (isText(a) && isText(b)) {
		return a.toLocaleUpperCase() === b.toLocaleUpperCase();
	}
	return a === b;
}

export default isEqual;
